import styles from './dashboardPage.module.css'
import { useState } from 'react'
import { useSystemStateHooks } from '../../../system'
import { Button } from '../../../../features/ui'
import { RoleDashboard } from '../role-dashboard/roleDashboard'
import { getDashboardRoles } from '../dashboard-widgets/dashboardRoles'

export const DashboardPage = () => {
    const [refreshKey, setRefreshKey] = useState(0)
    const [editing, setEditing] = useState(false)
    const { getUserRole } = useSystemStateHooks()
    const role = getUserRole()

    const hasDashboard = !!role && !!getDashboardRoles()[role]

    const now = new Date()
    const dateLabel = now.toLocaleDateString('es-AR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })

    const refresh = () => setRefreshKey(prev => prev + 1)

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1>Inicio</h1>
                    <p className="text-muted small mb-0">{dateLabel}</p>
                </div>
                <div className="d-flex gap-2">
                    {hasDashboard && !editing && (
                        <Button label="Personalizar" icon="grid-1x2" kind="tertiary" onClick={() => setEditing(true)} />
                    )}
                    <Button label="Actualizar" icon="arrow-clockwise" onClick={refresh} />
                </div>
            </div>
            {hasDashboard ? (
                <RoleDashboard key={refreshKey} role={role!} editing={editing} onFinishEditing={() => setEditing(false)} />
            ) : (
                <p className={styles.noRoleMsg}>Tu perfil no tiene un dashboard configurado. Contactá al administrador.</p>
            )}
        </section>
    )
}
